import * as openStreetApiMethods from '../../consts/api/nominatimApiMethods';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import OpenStreetApiClient from '../api/clients/openStreetApiClient';
import {showWarningNotification} from '../app/notificationService';
import {getLocalizedStrings} from '../localization/localizationService';
import log from '../logger/log';

const limit = 1;
const country = 'UA';
const format = 'json';

const getAddressByCoordinates = async (lat, lon) => {
    const params = {
        format,
        lat,
        lon,
        'accept-language': 'uk',
    };

    try {
        const response = await new OpenStreetApiClient().callGet({
            methodName: openStreetApiMethods.REVERSE,
            requestConfig: {
                params,
            },
        });

        return response;
    } catch (error) {
        console.error('Failed to reverse geocode:', error);
        return null;
    }
};

const getCoordinatesByAddress = async (address, city) => {
    const localizedStrings = getLocalizedStrings();

    const params = {
        format,
        limit,
        'accept-language': 'uk',
    };

    if (city && address) {
        params.city = city;
        params.street = address;
        params.country = country;
    } else {
        params.q = `${city || ''} ${address || ''}`;
    }

    try {
        const response = await new OpenStreetApiClient().callGet({
            methodName: openStreetApiMethods.SEARCH,
            requestConfig: {
                params,
            },
        });

        if (response && response.length > 0) {
            const {lat, lon, ...rest} = response[0] || {};

            return {
                lat: +lat,
                lon: +lon,
                ...rest,
            };
        } else {
            showWarningNotification(localizedStrings[localizationKeys.MAP_ADDRESS_SEARCH_FAILED]);
            log.info(`openStreetApiService: No coordinates for such address found`);

            return null;
        }
    } catch (error) {
        log.error('Error fetching coordinates:', error);
    }
    return null;
};

const formatAddress = (address) => {
    if (!address) return {};

    const {city, town, village, road = '', house_number = ''} = address || {};

    const cityName = city || town || village || '';
    const shortAddress = [road, house_number].filter(Boolean).join(', ');

    return {
        city: cityName,
        shortAddress,
    };
};

export default {
    getCoordinatesByAddress,
    getAddressByCoordinates,
    formatAddress,
};
